import { Component, OnInit, ViewChild } from '@angular/core';
import { ContenidosapiService } from 'src/app/services/contenidosapi.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-empresa',
    templateUrl: './empresa.component.html',
    styleUrls: ['./empresa.component.scss'],
    standalone: false
})
export class EmpresaComponent implements OnInit {
  @ViewChild('rootElement', { static: false }) rootElement: HTMLElement;

  historia: string;
  constructor(private cApi: ContenidosapiService, private actRoute: ActivatedRoute) {
    actRoute.params.subscribe(data => {
      this.getContenidos();
    });
  }

  ngOnInit() {
  }
  getContenidos() {
    this.cApi.getContenido('NUESTRA_HISTORIA').subscribe(data => {
      if (data) {
        this.historia = data.value;
      }
    });
  }
}
